(function() { module.exports = window["VueDemi"]; }());